import React, { useState, useEffect } from "react"
import StatesNav from "../Nav/StatesNav"
import Loader from "../Loader"

import "../../assets/styles/pages/home.scss"

// custom hook
import useGetPlots from "../../hooks/useGetPlot"

export default function Home() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth || null)
  const [viewPort, setViewPort] = useState(null)

  useEffect(() => {
    window &&
      window.addEventListener("resize", () => setWindowWidth(window.innerWidth))
    if (windowWidth >= 320) {
      setViewPort("small")
    }
    if (windowWidth >= 780) {
      setViewPort("medium")
    }
    if (windowWidth >= 1024) {
      setViewPort("large")
    }
  }, [windowWidth])

  const [err, loading, displayPlot] = useGetPlots("homepage", viewPort)

  if (loading) return <Loader />
  if (err) return <div>Error...</div>

  return (
    <div className="page-home">
      <div className="container">
        <div className="wrapper">
          <div className="content">
            <h3 className="title">
              National Allocation of Opioid Settlement Funds by State
            </h3>
            <h2 className="sub-title">
              Hover on the map below to view current opioid settlement funds in
              relation to the state population and state's drug use disorder and
              overdose rates. You may also select a state name in the drop-down
              below to learn more about the state's distribution of opioid
              settlement funds in relation to key trends.
            </h2>
            <div style={{ margin: "45px 0 15px 0" }}>
              <StatesNav />
            </div>
            {displayPlot("map")}
            <small style={{ display: "block", marginTop: 30 }}>
              The state settlement amounts were determined by a variety of
              factors, including opioid pills distributed in the state, number
              of fatal opioid overdoses and state population. These dollar
              amounts reflect settlements as of October 2022. There are
              additional pending state litigation cases, and the map will update
              accordingly.
            </small>
            <hr />
            <h3 className="title with-mt">
              State Drug Death Rates (per 100,000) by Opioid Litigation Funds
              per OUD Person
            </h3>
            <p>
              Funds from opioid litigation settlements are intended to directly
              support and protect the estimated Opioid Use Disorder (OUD)
              population within each participating state. The graphic below
              details the Drug Death Rate in each state, according to data
              available from the Centers for Disease Control and Prevention, in
              relation to settlement funds per estimated OUD person in the
              state. The OUD population estimate, indicated by the size of each
              bubble, is derived from Illicit Drug Use Disorder reporting from
              the National Survey on Drug Use and Health.
            </p>

            <h2 className="sub-title">
              Select a plot bubble to view data for each reporting state.
            </h2>
            {displayPlot("bubble")}
            <small style={{ display: "block", marginTop: 30 }}>
              <strong>Source:</strong> SAMHSA, Center for Behavioral Health
              Statistics and Quality, National Survey on Drug Use and Health,
              Quarters 1 and 4, 2020, 2019-2020 National Survey On Drug Use And
              Health: Model-Based Prevalence Estimates. Retrieved from:
              https://www.samhsa.gov/data/report/2019-2020-nsduh-state-prevalence-estimates;
              Centers for Disease Control and Prevention (CDC), National Center
              for Health Statistics. Multiple Cause of Death 1999-2019 on CDC
              WONDER Online Database, released 2021. Retrieved from:
              http://wonder.cdc.gov
            </small>
          </div>
        </div>
      </div>
    </div>
  )
}
